import { useState } from "react";
import CrmDashboard from "./CrmDashboard";
import CrmFirmalar from "./CrmFirmalar";
import CrmKisiler from "./CrmKisiler";
import CrmFirsatlar from "./CrmFirsatlar";
import CrmAktiviteler from "./CrmAktiviteler";
import CrmTeklifler from "./CrmTeklifler";
import CrmSektorTanimlari from "./CrmSektorTanimlari";

const TABS = [
  { id: "panel", label: "Panel", icon: "📊" },
  { id: "firmalar", label: "Firmalar", icon: "🏢" },
  { id: "kisiler", label: "Kisiler", icon: "👤" },
  { id: "firsatlar", label: "Firsatlar", icon: "🎯" },
  { id: "aktiviteler", label: "Aktiviteler", icon: "🗒️" },
  { id: "teklifler", label: "Teklifler", icon: "📃" },
  { id: "sektorler", label: "Sektor Tanimlari", icon: "⚙️" },
];

export default function CrmModule() {
  const [tab, setTab] = useState("panel");

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
      <div style={{ display: "flex", gap: 6, borderBottom: "1px solid var(--border-hairline)", paddingBottom: 0 }}>
        {TABS.map((t) => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            style={{
              background: "none", border: "none", cursor: "pointer",
              padding: "8px 16px", fontSize: 14, fontWeight: tab === t.id ? 600 : 400,
              color: tab === t.id ? "var(--accent-text)" : "var(--text-muted)",
              borderBottom: tab === t.id ? "2px solid var(--accent)" : "2px solid transparent",
              marginBottom: -1,
            }}
          >
            {t.icon} {t.label}
          </button>
        ))}
      </div>

      {tab === "panel" && <CrmDashboard />}
      {tab === "firmalar" && <CrmFirmalar />}
      {tab === "kisiler" && <CrmKisiler />}
      {tab === "firsatlar" && <CrmFirsatlar />}
      {tab === "aktiviteler" && <CrmAktiviteler />}
      {tab === "teklifler" && <CrmTeklifler />}
      {tab === "sektorler" && <CrmSektorTanimlari />}
    </div>
  );
}
